// extracted by mini-css-extract-plugin
module.exports = {"root":"Collezione_root__dcZs1","h1":"Collezione_h1__1vG7h","iframeWrap":"Collezione_iframeWrap__2MbId","iframe":"Collezione_iframe__3b21J"};